import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { IOptionsResponse } from '../../../common/common.types'
import { setPreferredLanguageOptions } from '../store/options.actions'

export function* getPreferredLanguageOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getPreferredLanguageOptions,
    ])
    const { entity } = response
    yield put(setPreferredLanguageOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getPreferredLanguageOptions() error: ${e}`))
  }
}

export function* getPreferredLanguageOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getPreferredLanguageOptions)
}
